import React from 'react';
import { ChartMode, ChartViewType } from './types';
import ErrorChartInfo from './ErrorChartInfo';
import ChartWithData from './ChartWithData';
import { useChartContext } from './ChartContext';
import ChartWrapper from './ChartWrapper';
import { UnreachableCaseError } from 'ts-essentials';
/**
 * This is a main component that based on chartView will delegate
 * what Chart to render
 */
const ChartMain = () => {
  const {
    metadata: { analysisId, mode, chartView },
  } = useChartContext();

  switch (chartView.type) {
    case ChartViewType.FallbackError:
    case ChartViewType.NoData:
    case ChartViewType.Cancelled:
    case ChartViewType.KobolError:
    case ChartViewType.CustomError:
    case ChartViewType.PermissionError:
      return <ErrorChartInfo {...chartView} />;
    case ChartViewType.Default: {
      if (mode === ChartMode.Compact) {
        return <ChartWrapper analysisId={analysisId} mode={mode} />;
      }
      return <ChartWithData />;
    }
    default:
      throw new UnreachableCaseError(chartView);
  }
};

export default ChartMain;
